import { useMemo } from 'react';
import uuid from 'uuid';

const useId = (prefix = ''): string => useMemo(() => `${prefix}${uuid()}`, [prefix]);

export default useId;
